import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const TRUNCATE_AT = 75;

const truncate = (text) => {
  if (text.length <= TRUNCATE_AT) return { short: text, truncated: false };
  let cut = text.lastIndexOf(' ', TRUNCATE_AT);
  if (cut < 20) cut = TRUNCATE_AT;
  return { short: text.slice(0, cut), truncated: true };
};

const DescriptionCell = ({ text, className }) => {
  const [open, setOpen] = useState(false);
  const { short, truncated } = truncate(text);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <p
        className={className}
        onClick={truncated ? (e) => { e.stopPropagation(); setOpen(true); } : undefined}
        role={truncated ? 'button' : undefined}
        tabIndex={truncated ? 0 : undefined}
        onKeyDown={truncated ? (e) => { if (e.key === 'Enter') { e.stopPropagation(); setOpen(true); } } : undefined}
        style={truncated ? { cursor: 'pointer' } : undefined}
      >
        {short}{truncated && <strong style={{ color: '#1a6fd4' }}>...</strong>}
      </p>
      {open && ReactDOM.createPortal(
        <div className="desc-overlay" onClick={() => setOpen(false)}>
          <div className="desc-popup" onClick={(e) => e.stopPropagation()}>
            <button className="desc-popup-close" onClick={() => setOpen(false)}>&#10005;</button>
            <p>{text}</p>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default DescriptionCell;
